import CountUp from "react-countup";
import { useReducedMotion } from "framer-motion";

function formatValue(end: number, suffix = "") {
    return `${end.toLocaleString("en-IN")}${suffix}`;
}

interface CountUpStatProps {
    end: number;
    suffix?: string;
    label: string;
    className?: string;
}

export function CountUpStat({ end, suffix = "", label, className = "" }: CountUpStatProps) {
    const shouldReduceMotion = useReducedMotion();
    const value = formatValue(end, suffix);

    return (
        <strong className={`block font-serif text-3xl font-normal text-white lg:text-4xl ${className}`} aria-label={`${value} ${label}`}>
            {shouldReduceMotion ? (
                value
            ) : (
                <CountUp end={end} suffix={suffix} duration={1.6} separator="," enableScrollSpy scrollSpyOnce preserveValue>
                    {({ countUpRef }) => <span ref={countUpRef}>{value}</span>}
                </CountUp>
            )}
        </strong>
    );
}
